import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const AboutClientButton = ({ sect }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/clients/?populate=deep`)
      .then(({ data }) => {
        setData(data.data);
      });
  }, []);

  return (
    <>
      <div
        className="rn-brand-area brand-separation pb--90 pt--90 "
        style={{
          backgroundImage: `url(${
            process.env.REACT_APP_BACKEND_URL +
            sect?.bgImg?.data?.attributes?.url
          })`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center service-style--3 mb--15">
                <h2 className="title" style={{ fontSize: "40px" }}>
                  {sect.title}
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="brand-style-2">
                {data.map((val, ind) =>
                  val.attributes.img.data.map((value, index) => (
                    <li key={index}>
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}${value.attributes.url}`}
                        alt="linnworks"
                      />
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="view-more-btn  text-center">
                <HashLink
                  className="rn-button-style--2 btn-solid"
                  to="/contact-us/#contact-page-form"
                >
                  <span>{sect.ctaButtontext}</span>
                </HashLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutClientButton;
